(function() {
'use strict';

angular
    .module('TR')
    .controller('FlightsFilter', FlightsFilter);

function FlightsFilter($scope,
                       flightSearch,
                       broker,
                       dateUtil,
                       resourceService,
                       $routeParams,
                       tripService,
                       flightsFilterService) {
    const ff = this;
    const limit = 5;
    const limitedFilters = ['FlightsByAirline', 'FlightsByDepartureAirportTitles', 'DepartureDates'];
    let agg;

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const selectedFlightId = _.get(trip, 'FlightsRequest.SelectedFlight.FlightId');
        flightSearch.getSearchResults(trip.FlightsRequest.AvailabilitySearchId, trip.TripId, selectedFlightId)
            .then(results => {
                if (results && trip && trip.FlightsRequest) {
                    configureFilterLimits(results);
                    configureFilterOptions(results, trip.FlightsRequest);
                }
            });
    });

    function configureFilterLimits(results) {
        agg = results.CombinedDates.UnfilteredAggregates;
        flightsFilterService.arrayifyAggregates(agg, limitedFilters);

        if (ff.filterLimits == null) {
            ff.filterLimits = {};
            limitedFilters.forEach(function(f) {
                ff.filterLimits[f] = agg[`${f}Array`].length <= limit ? agg[`${f}Array`].length : limit;
            });
        }

        ff.moreLess = function(filterName) {
            if (!ff.filterLimits || agg[`${filterName}Array`].length <= limit) {
                return '';
            }
            if (ff.filterLimits[filterName] <= limit) {
                return resourceService.get('MORE');
            }
            if (ff.filterLimits[filterName] > limit) {
                return resourceService.get('FEWER');
            }
        };

        ff.toggleLimit = function(filterName) {
            ff.filterLimits[filterName] = (ff.filterLimits[filterName] < agg[`${filterName}Array`].length) ? agg[`${filterName}Array`].length : limit;
        };
    }

    function configureFilterOptions(results, request) {
        const codes = request.SelectedDepartureAirport.Code.split(',');
        ff.isAirportFilterAvailable = codes.length > 1;

        const dates = Object.keys(results.CombinedDates.UnfilteredAggregates.DepartureDates);
        ff.isDatesFilterAvailable = true;
        if (dates.length === 1) {
            tripService.getFlightsRequestDepartureDate($routeParams.tripId).then(function(date) {
                ff.isDatesFilterAvailable = !dateUtil.sameDay(dates[0], date);
            });
        }
    }

    broker.subscribe('FlightsFilterCtrl', 'flightsListUpdated', function(ev) {
        updateFilter();
        configureFilterLimits(ev.data);
        watchFilter();
    });

    broker.subscribe('FlightsFilterCtrl', 'newSearchTriggered', newSearchTriggered);

    let canceller;
    function stopWatch() {
        if (canceller != null) {
            canceller();
        }
    }

    /* when a new search is triggered we will be reseting the filters. This means that we need to
       suspend the watch on the filter because the callback function for the new search will
       copy the new aggregate data into the (reset) filter object and trigger the watch (which
       will then trigger a call to filter) otherwise */
    function newSearchTriggered() {
        ff.filterLimits = null;
        ff.resetFilters(true).then(stopWatch);
    }

    //set up functions to delegate to the flightSearch counterparts while suspending the filter watcher
    ['removeArrayFilter', 'resetArrayFilter', 'resetRangeFilter', 'resetFilters', 'resetBooleanFilter'].forEach(function(fn) {
        ff[fn] = function(...args) {
            stopWatch();
            return flightSearch[fn](...args).then(watchFilter).then(updateFilter);
        };
    });

    function updateFilter() {
        ff.filter = flightSearch.getFilter();
    }


    function watchFilter() {
        stopWatch();
        canceller = $scope.$watch('ff.filter', _.debounce(function(f, o) {
            if (f == null || f === o) {
                return;
            }
            flightSearch.filter().then(updateFilter);
        }, 300), true);
    }

    flightSearch.getFilterLazy().then(function(filter) {
        ff.filter = filter;
    });

    $scope.$on('$destroy', function() {
        broker.unsubscribe('FlightsFilterCtrl');
    });
}
})();
